export const baseProcessRequestInfoFactory = (baseUrl: string) => {
  return (info: RequestInfo): RequestInfo => {
    return typeof info === 'object'
      ? { ...info, url: `${baseUrl}${info.url}` }
      : `${baseUrl}${info}`;
  };
};
